import { render, staticRenderFns } from "./SummaryMailTables.vue?vue&type=template&id=2534f52b&scoped=true&"
import script from "./SummaryMailTables.vue?vue&type=script&lang=js&"
export * from "./SummaryMailTables.vue?vue&type=script&lang=js&"
import style0 from "./SummaryMailTables.vue?vue&type=style&index=0&id=2534f52b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2534f52b",
  null
  
)

export default component.exports